import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const contextPath = '/dashboard'

export const useGetThisNext = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`DASHBOARD_THIS_NEXT`], 
                () => getThisNext(),
                {
                    refetchInterval:180000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                }
                );
}

const getThisNext = async() => {
    const retVal = await instance.get(contextPath+'/thisNext', null)
    .then((res)=>{
        return res.data;
    })

    return retVal;
}

export const useGetStatusCount = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`DASHBOARD_STATUS_COUNT`], 
                () => getStatusCount(),
                {
                    refetchInterval:180000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                }
                );
}

const getStatusCount = async() => {
    const retVal = await instance.get(contextPath+'/statusCount', null)
    .then((res)=>{
        return res.data;
    })

    return retVal;
}

export const useGetProjectSchedule = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`DASHBOARD_PROJECT_SCHEDULE`], 
                () => getProjectSchedule(),
                {
                    refetchInterval:180000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                }
                );
}

const getProjectSchedule = async() => {
    const retVal = await instance.get(contextPath+'/projectSchedule', null)
    .then((res)=>{
        return res.data;
    })

    return retVal;
}

export const useGetNotice = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`DASHBOARD_NOTICE`], 
                () => getNotice(),
                {
                    refetchInterval:180000,
                    onSuccess:()=>queryClient.setQueryData(['REFRESH_TIME'],{time:new Date()}),
                }
                );
}

const getNotice = async() => {
    const retVal = await instance.get(contextPath+'/notice', null)
    .then((res)=>{
        return res.data;
    })

    return retVal;
}